/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { SentryErrorFallback } from './components/Modals/ErrorModal';
import Routes from './router/Routes';

function App() {
  return (
    <Sentry.ErrorBoundary fallback={SentryErrorFallback} showDialog>
      <BrowserRouter>
        <>{Routes}</>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;
